import React, { Component } from 'react';
import { Button, Table, Form, Input, Divider, message, Modal, Select, Tooltip } from 'antd';
import axios from '../../service/index'
import './auditManagement.less'
const { Option } = Select;
class CommentModer extends Component {

	constructor(props) {
		super(props)
		this.state = {
			approvalStatus: '',
			content: '',
			visible: false,
			lableListData: [],
			total: 0,
			userName: '',
			searchData: {
				pageNum: 1,
				pageSize: 10,
			},
			detailId: '',
			tableData: [],
			labelName: '',
			labelId: null,
			ids: [],
      detailTableList: [],
			optionList: [],
			columns: [
				{
					title: '评论内容',
					dataIndex: 'content',
					key: 'content',
					ellipsis: true,
					render: (text, record) => (
						<Tooltip placement="topLeft" title={text}>{text}</Tooltip>
					)
				},
				{
					title: '面经标题',
					dataIndex: 'interviewExperienceName',
					key: 'interviewExperienceName',
					align: 'center'
				},
				{
					title: '评论人',
					dataIndex: 'userName',
					key: 'userName',
					align: 'center'
				},
				{
					title: '评论时间',
					dataIndex: 'createTime',
          width: '200px',
					key: 'createTime',
					align: 'center'
				},
				{
					title: '审核状态',
					width: '120px',
					dataIndex: 'approvalStatus',
					key: 'approvalStatus',
					align: 'center',
					render: (record) => {
						if (record === 0) {
							return '待审核'
						}
						if (record === 1) {
							return '通过'
						}
						if (record === 2) {
							return '不通过'
						}
					}
				},
				{
					title: '审核记录',
          width: '120px',
					key: 'aStatus',
					align: 'center',
          render: (record) => 
						 <div>
              { record.approvalStatus === 0?<span className='detail-btn disabled-btn'> 详情 </span>
								:<span className='detail-btn' onClick={() => {this.openhandle(record.id)}}> 详情 </span>
							}
            </div>
					
				},
				{
					title: '操作',
					key: 'operation',
          width: '140px',
					align: 'center',
					render: (record) => <div>
						{record.approvalStatus === 0 ||record.approvalStatus === 2? <span style={{ marginRight: '15px', color: '#277FFF', cursor: 'pointer' }} onClick={() => {
							Modal.confirm({
								title: '提示',
								okText: "确认",
								cancelText: "取消",
								content: '评论审核通过后将在用户端展示，你确定要通过吗？',
								onOk: () => {
										axios.post('ugc/iereview/pass', {
											id: record.id
										}).then(res => {
											if (res.data.code === '200') {
												message.success('审核通过')
												this.iereviewList()
											} else {
												message.error(res.data.msg)
											}
										})
									}
								})
						}}>通过</span>:''}
						{record.approvalStatus === 0 ||record.approvalStatus === 1?  <span style={{ color: '#277FFF', cursor: 'pointer' }} onClick={() => {
							Modal.confirm({
								title: '提示',
								okText: "确认",
								cancelText: "取消",
								content: '审核不通过的评论仅作者可见，其他用户不可见，你确定要不通过吗？',
								onOk: () => {
									axios.post('ugc/iereview/noPass', {
										id: record.id
									}).then(res => {
										if (res.data.code === '200') {
											message.success('屏蔽成功')
											this.iereviewList()
										} else {
											message.error(res.data.msg)
										}
									})
								}
							})
						}}>不通过</span>:''}
					</div>
				},
			],
      detailColumns: [
        {
          title: '评论内容',
          dataIndex: 'content',
          key: 'content',
          align: 'center',
					ellipsis: true,
          render: (record) => (
            <Tooltip placement="topLeft" title={record}>{record}</Tooltip>
					)
        },
        {
          title: '审核员',
          dataIndex: 'approvalUserName',
          key: 'approvalUserName',
          align: 'center',
        },
        {
          title: '审核时间',
          dataIndex: 'approvalTime',
          key: 'approvalTime',
          align: 'center',
        },
        {
          title: '审核结果',
          dataIndex: 'approvalReason',
          key: 'approvalReason',
          align: 'center',
          render: (record) => (
						<Tooltip placement="topLeft" title={record}>{record}</Tooltip>
					)
        }
      ]
		}
	}
	componentDidMount() {
		this.iereviewList()
	}

	iereviewList = () => {
		axios.post('ugc/iereview/list', {
			...this.state.searchData,
			approvalStatus: this.state.approvalStatus,
			content: this.state.content,
			userName: this.state.userName,
		}).then(res => {
			if (res.data.code === '200') {
				this.setState({
					tableData: res.data.data.list,
					total: res.data.data.total
				})
			}
		})
	}
	handleCancel = () => {
		this.setState({
			visible: false,
			detailTableList: []
		})
	};
	openhandle (id) {
		axios.get(`ugc/iereview/approvalRecords/${id}`).then(res => {
			if(res.data.code === '200'){
				this.setState({
					visible: true,
					detailTableList: res.data.data
				})
			}
		})
	};
	batchPass() {
    Modal.confirm({
      title: '提示',
      okText: "确认",
      cancelText: "取消",
      content: '评论审核通过后将在用户端展示，你确定要通过吗？',
      onOk: () => {
        axios.post('ugc/iereview/batchPass', {
          ids: this.state.ids
        }).then(res => {
          if (res.data.code === '200') {
            message.success('批量操作通过成功')
            this.iereviewList()
						this.setState({
							ids: []
						})
          } else {
            message.error(res.data.msg)
          }
        })
      }
   })
	}
	batchReject() {
    Modal.confirm({
      title: '提示',
      okText: "确认",
      cancelText: "取消",
      content: '审核不通过的评论仅作者可见，其他用户不可见，你确定要不通过吗？',
      onOk: () => {
        axios.post('ugc/iereview/batchNoPass', {
          ids: this.state.ids
        }).then(res => {
          if (res.data.code === '200') {
            message.success('批量操作屏蔽成功')
            this.iereviewList()
						this.setState({
							ids: []
						})
          } else {
            message.error(res.data.msg)
          }
        })
      },
    });
		
	}
	getOption() {
		axios.get('subjectController/getOption').then( res => {
			if(res.data.code === '200'){
				let arr = res.data.data
				this.setState({
					optionList: arr
				})
			}
		})
	}
	render() {
		const { tableData, columns, total, show, visible, detailTableList, detailColumns } = this.state
		const pagination = {
			showSizeChanger: true,
			total: total,
			pageSizeOptions: ['10', '20', '30', '40'],
			showTotal: () => `共 ${total} 条`,
			onShowSizeChange: (current, pageSize) => {
				let searchData = this.state.searchData
				searchData.pageNum = current
				searchData.pageSize = pageSize
				this.iereviewList(searchData)
			},
			onChange: (current) => {
				let searchData = this.state.searchData
				searchData.pageNum = current
				this.iereviewList(searchData)
			},
		}
		const rowSelection = {
			onChange: (selectedRowKeys, selectedRows) => {
				this.setState({
					ids: selectedRowKeys
				})
			},
			onSelect: (record, selected, selectedRows) => {
				this.setState({
					show: selected
				})
			},
			onSelectAll: (selected, selectedRows, changeRows) => {
				this.setState({
					show: selected
				})
			},
		};
		return (
			<div>
				<span style={{ display: 'flex', alignItems: 'center', fontSize: '18px', fontWeight: '600' }}>面经评论审核</span>
				<Divider />
				<div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px',alignItems: 'center' }}>
					<div>
						<Input allowClear value={this.state.content} style={{ width: '250px', height: '40px', marginRight: '20px' }}
							placeholder="请输入评论关键字"
							onChange={(e) => {
								this.setState({
									content: e.target.value
								})
							}}
						></Input>
            <Input allowClear value={this.state.userName} style={{ width: '250px', height: '40px', marginRight: '20px' }}
							placeholder="请输入评论人"
							onChange={(e) => {
								this.setState({
									userName: e.target.value
								})
							}}
						></Input>
						<Select  placeholder="审核状态" value={this.state.approvalStatus} allowClear style={{ width: 140, height: '40px', marginRight: '20px' }} onChange={(value)=>{
							this.setState({
								approvalStatus: value
							})
						}}>
              <Option value="">全部</Option>
							<Option value="0">待审核</Option>
							<Option value="1">通过</Option>
							<Option value="2">不通过</Option>
						</Select>
						<Button className='my-button-primary' type='primary' onClick={() => {this.iereviewList()}}>搜索</Button>
						<span className="my-button-txt" style={{marginLeft: '20px'}} onClick={() => {
							this.setState({
								approvalStatus: undefined,
								content: '',
								userName: ''
							},()=>{
								this.iereviewList()
							})
						}}>重置</span>
					</div>
					{show && <div>
						<span className="my-button-txt" onClick={() => {
							this.batchPass()
						}}>全部通过</span>
						<span className="my-button-danger" style={{ marginLeft: '20px' }} onClick={() => {
							this.batchReject()
						}}>全部不通过</span>
					</div>}
				</div>
				<Table rowSelection={rowSelection} dataSource={tableData} columns={columns} rowKey={record => record.id} pagination={pagination} rowClassName={(record, index) => (index % 2 !== 0 ? 'table-line' : '')}/>
        <Modal
					width={1200}
					title='审核记录'
					okText="确认"
					cancelText="取消"
					visible={visible}
					onOk={() => { this.handleOk() }}
					onCancel={() => { this.setState({ visible: false }) }}
					destroyOnClose
					zIndex={1000}
					maskClosable={false}
				>
					<div>
						
						<div style={{ overflowY: 'auto' }}>
								<Table
									ref="table"
									pagination={false}
									dataSource={detailTableList}
									columns={detailColumns}
									bordered
									rowKey={record => record.id}
									rowClassName={(record, index) => (index % 2 !== 0 ? 'table-line' : '')}
								/>
						</div>
					</div>


				</Modal>
			</div>
		)
	}

};

export default Form.create()(CommentModer)
